import React, { useState, useEffect } from 'react';
import shortUUID from "short-uuid";
import apiClient from '../../apiClient';
import { SSO_URL } from '../../env';
import { GET_CHANNEL_STORAGE_DETAILS, SAVE_CHANNEL_STORAGE_DETAILS } from '../../apiClient/apiEndpoints';

const generateShortUUID = () => shortUUID.generate();

const convertToArray = (obj) => {
  return Object.entries(obj).map(([key, value]) => ({
    key: generateShortUUID(),
    name: key,
    value: value,
    editable: false,
  }));
};

const convertToObject = (arr) => {
  const obj = {};
  arr.forEach(({ name, value }) => {
    if (name) obj[name] = value;
  });
  return obj;
};

const GeneralConfig = ({ id }) => {
  const [details, setDetails] = useState([]);
  const [configurationId, setConfigurationId] = useState(null);
  const [configurationName, setConfigurationName] = useState("");
  const [loading, setLoading] = useState(false);

  const getChannelStorageConfig = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${GET_CHANNEL_STORAGE_DETAILS}/${id}`);
      setConfigurationId(data.id);
      setConfigurationName(data.name);
      const formatted = convertToArray(data?.data || {});
      setDetails(formatted);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getChannelStorageConfig();
  }, [id]);

  const handleChange = (key, field, value) => {
    setDetails(prev =>
      prev.map(item =>
        item.key === key ? { ...item, [field]: value } : item
      )
    );
  };

  const handleCancel = () =>{
    getChannelStorageConfig()
  }

  const handleSaveConfiguration = async () => {
    if (loading) return;
    try {
      let bodyData = {
        name: configurationName,
        data: convertToObject(details)
      }
      setLoading(true)
      await apiClient.post(`${SSO_URL}${SAVE_CHANNEL_STORAGE_DETAILS}/${configurationId}`, bodyData);
      getChannelStorageConfig();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className='application-main not-main mt-3'>
        <h6> Storage Configuration </h6>
        <div className='row w-100 mt-2'>
          <div className='col-12'>
            <div className="col-6 standardinput mt-3">
              <label> Name<span>*</span></label>
              <input
                autoComplete="off"
                name="configurationname"
                id="configurationname"
                className="input form-control"
                type="text"
                value={configurationName}
                onChange={(e) => setConfigurationName(e.target.value)}
              />
            </div>

            <div className="variable-list">
              <div className="parent">
                <div> Key </div>
                <div> Value </div>
              </div>
              {details?.map((item, index) => (
                <div className="child" key={item.key}>
                  <div className="standardinput">
                    <input
                      type="text"
                      disabled={true}
                      value={item.name}
                      className="input form-control"
                      onChange={(e) => handleChange(item.key, "name", e.target.value)}
                    />
                  </div>
                  <div className="standardinput">
                    <input
                      type="text"
                      disabled={!item.editable}
                      value={item.value}
                      className="input form-control"
                      onChange={(e) => handleChange(item.key, "value", e.target.value)}
                    />
                  </div>
                  <div className="edit-remove">
                    <button onClick={() => handleChange(item.key, "editable", !item.editable) } >
                      {item.editable ? "Lock" : "Edit"}
                    </button>
                  </div>
                </div>
              ))}
            </div>

          </div>        

          <div className="footerbtn mt-4">
            <button className='cancel' onClick={handleCancel} > Cancel </button>
            {loading ?
              <button className='loading save'> <svg viewBox="25 25 50 50"> <circle r="20" cy="50" cx="50"></circle> </svg> </button>
              :
              <button className='save' onClick={handleSaveConfiguration}>Save</button>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default GeneralConfig;